import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M54.237 40.702c1.578-1.546 2.573-3.764 2.573-6.236 0-4.672-3.532-8.459-7.891-8.459h-3.122c2.047-1.232 3.498-2.288 3.498-5.872 0-2.725-.902-6.364-5.501-7.459h-4.293C34.748.872 21.469 4.233 21.469 4.233c2.377 1.312 2.541 8.442 2.541 8.442h-3.804c-4.436 1.177-5.501 4.546-5.501 7.459 0 3.584 1.451 4.64 3.498 5.872H15.08c-4.357 0-7.891 3.787-7.891 8.459 0 2.473.995 4.69 2.573 6.236-3.614 1.313-6.227 5.067-6.227 9.501 0 5.526 4.053 10.006 9.053 10.006H51.41c5 0 9.053-4.479 9.053-10.006.001-4.432-2.611-8.186-6.226-9.5z" }, null, -1)
  ])))
}
export default { render };